import React from 'react';
import Button from '../../components/Form/Button';

interface CrewActionButtonsProps {
  selectedCount: number;
  totalCount: number;
  allSelected: boolean;
  onSelectAll: () => void;
  onPrint: () => void;
  onDownloadWord: () => void;
  onEmailWord: () => void;
}

const CrewActionButtons: React.FC<CrewActionButtonsProps> = ({
  selectedCount, totalCount, allSelected,
  onSelectAll, onPrint, onDownloadWord, onEmailWord,
}) => (
  <div className="flex flex-wrap gap-4 items-center">
    <Button type="button" variant="secondary" onClick={onSelectAll}>
      {allSelected ? 'إلغاء تحديد الكل' : 'تحديد الكل'}
    </Button>
    
    {selectedCount > 0 && (
      <>
        <Button type="button" variant="primary" onClick={onPrint}>
          طباعة ({selectedCount})
        </Button>
        <Button type="button" variant="secondary" onClick={onDownloadWord}>
          تحميل Word
        </Button>
        <Button type="button" variant="secondary" onClick={onEmailWord}>
          إرسال بالبريد الإلكتروني
        </Button>
      </>
    )}
    
    <div className="text-sm text-gray-600">
      تم تحديد {selectedCount} من أصل {totalCount} فرد طاقم
    </div>
  </div>
);

export default CrewActionButtons;
